import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'acl-slider',
  standalone: false,
  templateUrl: './slider.component.html',
  styleUrl: './slider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SliderComponent {
  slidersData = input<any[]>();
}
